import { Timeline, TimelineMax } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Anchor} from "../core/Anchor";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array, Callback} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import * as VO from "../data/VO";
import {Keyboard} from "../gameobjects/Keyboard";
import {SplashPlayButton} from "../gameobjects/SplashPlayButton";
import {SplashScreenLayout} from "../layout/SplashScreenLayout";

export class SplashScreen extends HLF.SplashScreen {

    public readonly bg = this.addChild(new PIXI.Graphics());
    public readonly cloudContainer = this.addChild(new PIXI.Container());
    public readonly cloud = array(() => this.cloudContainer.addChild(new Sprite()));
    public readonly earth = this.addChild(new Sprite());
    public readonly bee = this.addChild(new Sprite());
    public readonly ladybug = this.addChild(new Sprite());
    public readonly loaderEmpty = this.addChild(new Sprite()); // static
    public readonly loaderFull = this.addChild(new Sprite());

    public init(pSize: PIXI.Point) {
        this.bg.beginFill(0xC8E2F4, 1);
        this.bg.drawRect(0, 0, 2, 2);
        this.bg.endFill();
        this.bg.width = pSize.x;
        this.bg.height = pSize.y;
        SplashScreenLayout.call(this);
        this.loaderEmpty.visible = false;
        this.loaderFull.visible = false;
        super.init(pSize);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.position.set((pSize.x - 1024) / 2, 0);
        this.bg.x = -(pSize.x - 1024) / 2;
        this.bg.width = pSize.x;
        this.bg.height = pSize.y;
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
        const bgm = HLF.Application.instance.audio.getAudioTrack("main_menu_loop", HLF.AudioCategory.BGM) ?? HLF.Application.instance.audio.createAudioTrack("main_menu_loop", HLF.AudioCategory.BGM);
        if (bgm.isPlaying() === false) {
            bgm.setLooped(true);
            bgm.play();
        }
    }
}
